import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import types from '../../../types';
import check from '../../../assets/icon-check.svg';
import styles from './styles.module.scss';

const Option = ({
                  children,
                  value,
                  selectOption,
                  isSelected = false
}) => (
  <div
    onClick={() => selectOption(value)}
    className={classnames(styles.optionContainer, {[styles.selected]: isSelected})}
  >
    <div className={styles.optionLabel}>
      {children}
      <img src={check} alt="selected" className={styles.optionCheck}/>
    </div>
  </div>
);

Option.propTypes = {
  ...types.children,
  value: PropTypes.object,
  selectOption: PropTypes.func.isRequired,
  isSelected: PropTypes.bool
};

export default Option;
